export { ContentPageContainer, ContentPageTitle, ContentPageWrapper } from './styled';
